<app-overlay-loader [show]="isLoading"></app-overlay-loader>
<app-header></app-header>
<div class="main-container d-flex">
    <app-sidebar></app-sidebar>
    <div class="container-fluid h-100p overflow-y-scroll user-account-main px-2 px-sm-3 px-lg-4">
        <div class="account-design-shell">
            <div class="header-section account-topbar">
                <div class="tabs-container">
                    <button class="tab-button account-pill" [class.active]="selectedTab === 'account-details'" (click)="onTabChange('account-details')">
                        <i class="bi bi-file-text"></i>
                        <span>Account Details</span>
                    </button>
                    <button class="tab-button account-pill" [class.active]="selectedTab === 'subscription'" (click)="onTabChange('subscription')">
                        <i class="bi bi-bar-chart"></i>
                        <span>My Subscription</span>
                    </button>
                </div>
                <div class="header-actions">
                    <div class="two-factor-toggle account-two-factor">
                        <span class="two-factor-label">Enable two factor Authentication</span>
                        <label class="toggle-switch">
                            <input type="checkbox" [(ngModel)]="twoFactorEnabled" (change)="onTwoFactorToggle()">
                            <span class="toggle-slider"></span>
                        </label>
                    </div>
                    <button class="btn logout-btn account-logout-btn" (click)="onLogOutButtonClick()">
                        Log out <i class="bi bi-box-arrow-right"></i>
                    </button>
                </div>
            </div>

            <!-- Divider -->
            <!-- <hr class="custom-divider" /> -->

            <!-- Account Details Tab Content -->
            <div class="tab-content" *ngIf="selectedTab === 'account-details'">
                <div class="profile-summary-card">
                    <div class="profile-identity">
                        <div class="avatar-box">{{ (userData.name || 'U').charAt(0) | uppercase }}</div>
                        <div class="identity-text">
                            <h2>{{ userData.name }}</h2>
                            <p>{{ userData.email }} &middot; {{ userData.roleType }}</p>
                        </div>
                    </div>
                    <div class="metrics-strip">
                        <div class="metric-chip">
                            <span class="metric-label">CURRENT PLAN TOTAL</span>
                            <span class="metric-value">{{ userData.totalCredits | creditsLabel }}</span>
                        </div>
                        <div class="metric-chip metric-chip-highlight">
                            <span class="metric-label">CURRENT PLAN REMAINING</span>
                            <span class="metric-value">{{ userData.remainingCredits | creditsLabel }}</span>
                        </div>
                        <div class="metric-chip">
                            <span class="metric-label">TODAY</span>
                            <span class="metric-value">{{ userData.todayCount }}</span>
                        </div>
                    </div>
                </div>

                <div class="account-cards-grid">
                    <section class="detail-card">
                        <h6 class="detail-card-title">General Info</h6>
                        <div class="detail-card-body">
                            <div class="info-box">
                                <div class="icon-circle"><i class="bi bi-person"></i></div>
                                <div class="info-content">
                                    <span class="info-content-title">Name</span>
                                    <span class="info-content-text">{{ userData.name }}</span>
                                </div>
                            </div>

                            <div class="info-box">
                                <div class="icon-circle"><i class="bi bi-envelope"></i></div>
                                <div class="info-content">
                                    <span class="info-content-title">Email</span>
                                    <span class="info-content-text">{{ userData.email }}</span>
                                </div>
                            </div>

                            <div class="info-box">
                                <div class="icon-circle"><i class="bi bi-lock"></i></div>
                                <div class="info-content">
                                    <span class="info-content-title">Password</span>
                                    <span class="info-content-text">**********</span>
                                </div>
                                <button class="btn btn-outline-success change-btn" (click)="openChangePasswordDialog()">
                                    <i class="bi bi-key"></i>
                                    Change
                                </button>
                            </div>

                            <div class="info-box mb-0">
                                <div class="icon-circle"><i class="bi bi-person-badge"></i></div>
                                <div class="info-content">
                                    <span class="info-content-title">Role Type</span>
                                    <span class="info-content-text">{{ userData.roleType }}</span>
                                </div>
                            </div>
                        </div>
                    </section>

                    <section class="detail-card">
                        <h6 class="detail-card-title">License Details</h6>
                        <div class="detail-card-body">
                            <div class="info-box">
                                <div class="icon-circle"><i class="bi bi-journal-text"></i></div>
                                <div class="info-content">
                                    <span class="info-content-title">Expiry Date</span>
                                    <span class="info-content-text">{{ userData.licenseExpiry }}</span>
                                </div>
                            </div>

                            <div class="info-box">
                                <div class="icon-circle"><i class="bi bi-search"></i></div>
                                <div class="info-content">
                                    <span class="info-content-title">Current Active Plan Total Credits</span>
                                    <span class="info-content-text">{{ userData.totalCredits | creditsLabel }}</span>
                                </div>
                            </div>

                            <div class="info-box">
                                <div class="icon-circle"><i class="bi bi-piggy-bank"></i></div>
                                <div class="info-content">
                                    <span class="info-content-title">Current Active Plan Remaining Credits</span>
                                    <span class="info-content-text">{{ userData.remainingCredits | creditsLabel }}</span>
                                </div>
                            </div>

                            <div class="info-box">
                                <div class="icon-circle"><i class="bi bi-calendar-day"></i></div>
                                <div class="info-content">
                                    <span class="info-content-title">Today Count</span>
                                    <span class="info-content-text">{{ userData.todayCount }}</span>
                                </div>
                            </div>

                            <div class="info-box mb-0">
                                <div class="icon-circle"><i class="bi bi-award"></i></div>
                                <div class="info-content">
                                    <span class="info-content-title">License Name</span>
                                    <span class="info-content-text">{{ userData.licenseName }}</span>
                                </div>
                            </div>
                        </div>
                    </section>

                    <section class="detail-card contact-us-card">
                        <h6 class="detail-card-title">Contact us</h6>
                        <div class="detail-card-body">
                            <div class="info-box">
                                <div class="icon-circle"><i class="bi bi-envelope"></i></div>
                                <div class="info-content">
                                    <span class="info-content-title">Email</span>
                                    <a class="info-content-text contact-us-link" [href]="'mailto:' + supportEmail">{{ supportEmail }}</a>
                                </div>
                            </div>

                            <div class="info-box mb-0">
                                <div class="icon-circle"><i class="bi bi-telephone"></i></div>
                                <div class="info-content">
                                    <span class="info-content-title">Phone</span>
                                    <a class="info-content-text contact-us-link" [href]="'tel:' + supportPhoneTel">{{ supportPhone }}</a>
                                </div>
                            </div>
                        </div>
                    </section>
                </div>
            </div>

            <!-- My Subscription Tab Content -->
            <div class="tab-content" *ngIf="selectedTab === 'subscription'">
                <div class="subscription-container">
                    <div *ngIf="isLoadingSubscription" class="text-center py-4">
                        <p class="text-white">Loading subscription details...</p>
                    </div>
                    <div class="row g-3 g-xl-4 subscription-layout-row" *ngIf="!isLoadingSubscription">
                        <!-- Left Side: Plans Section -->
                        <div class="col-12 col-xl-8">
                            <div class="subscription-section" *ngIf="subscriptionData.availableCredits != null">
                                <div class="subscription-card available-credits-card">
                                    <div class="available-credits-row">
                                        <div class="available-credits-label">
                                            <i class="bi bi-wallet2"></i>
                                            <span>{{ subscriptionData.currentPlan?.isUnlimited ? 'Active plan credits' : 'Total available credits' }}</span>
                                        </div>
                                        <span class="available-credits-value">{{ subscriptionData.availableCredits | creditsLabel }}</span>
                                    </div>
                                </div>
                            </div>

                            <!-- Current Plan Section -->
                            <div class="subscription-section" *ngIf="subscriptionData?.currentPlan">
                                <div class="subscription-card">
                                    <h4 class="subscription-card-title">Current Plan</h4>
                                    <div class="subscription-card-body">
                                        <div class="plan-header">
                                            <h3 class="plan-name">{{ subscriptionData.currentPlan.name }}</h3>
                                            <span class="plan-badge active-badge">
                                                <i class="bi bi-check-circle-fill"></i>
                                                Active
                                            </span>
                                        </div>
                                        <div class="plan-credits-info" *ngIf="!subscriptionData.currentPlan.isUnlimited">
                                            <span class="credits-used">{{ subscriptionData.currentPlan.usedCredits }}</span>
                                            <span class="credits-separator">/</span>
                                            <span class="credits-total">{{ subscriptionData.currentPlan.totalCredits }} credits</span>
                                        </div>
                                        <div class="plan-credits-info" *ngIf="subscriptionData.currentPlan.isUnlimited">
                                            <span class="credits-total">infinite searches until expiry</span>
                                        </div>
                                        <div class="progress-bar-container" *ngIf="!subscriptionData.currentPlan.isUnlimited">
                                            <div class="progress-bar" [style.width.%]="getCreditUsagePercentage()"></div>
                                        </div>
                                        <div class="plan-details">
                                            <div class="plan-detail-item">
                                                <i class="bi bi-calendar3 plan-detail-icon"></i>
                                                <span class="plan-detail-text">{{ subscriptionData.currentPlan.daysLeft }} days left</span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <!-- Upcoming Plan(s) Section -->
                            <div class="subscription-section" *ngIf="subscriptionData?.upcomingPlans && subscriptionData.upcomingPlans.length > 0">
                                <div class="subscription-card upcoming-plan-card">
                                    <h4 class="subscription-card-title">Upcoming Plan(s)</h4>

                                    <!-- First Upcoming Plan (Full Details with Activate Button) -->
                                    <div class="subscription-card-body" *ngIf="subscriptionData.upcomingPlans.length > 0">
                                        <div class="plan-header">
                                            <h3 class="plan-name">{{ subscriptionData.upcomingPlans[0].name }} <span class="text-light"> ({{
                        subscriptionData.upcomingPlans[0].totalCredits }} credits)</span></h3>
                                            <span class="plan-badge upcoming-badge">Upcoming</span>
                                        </div>
                                        <p class="upcoming-plan-note">
                                            Starts automatically when the current plan expires, runs out, or does not have enough credits for a search. Leftover current credits move to this plan. You can also activate it using the button below.
                                        </p>
                                        <button type="button" class="activate-plan-btn" (click)="onActivatePlanClick(subscriptionData.upcomingPlans[0])" [disabled]="isActivatingPlan === subscriptionData.upcomingPlans[0].subscriptionId" [attr.aria-busy]="isActivatingPlan === subscriptionData.upcomingPlans[0].subscriptionId">
                                            <i class="bi bi-play-circle-fill" *ngIf="isActivatingPlan !== subscriptionData.upcomingPlans[0].subscriptionId"></i>
                                            <span *ngIf="isActivatingPlan === subscriptionData.upcomingPlans[0].subscriptionId">Activating...</span>
                                            <span *ngIf="isActivatingPlan !== subscriptionData.upcomingPlans[0].subscriptionId">Activate
                                                Plan</span>
                                        </button>
                                    </div>

                                    <!-- Remaining Upcoming Plans (One Line Format) -->
                                    <div class="remaining-plans-container" *ngIf="subscriptionData.upcomingPlans.length > 1">
                                        <div class="remaining-plan-item" *ngFor="let upcomingPlan of subscriptionData.upcomingPlans.slice(1); let i = index">
                                            <span class="remaining-plan-name">{{ upcomingPlan.name }}</span>
                                            <span class="remaining-plan-credits">({{ upcomingPlan.totalCredits }} credits)</span>
                                            <span class="remaining-plan-badge">Upcoming</span>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <!-- No Subscription Message -->
                            <div class="subscription-card" *ngIf="!subscriptionData?.currentPlan && (!subscriptionData?.upcomingPlans || subscriptionData.upcomingPlans.length === 0)">
                                <p class="text-white text-center py-3">No active subscription found. Please add a plan to get started.</p>
                            </div>
                        </div>

                        <!-- Right Side: Quick Links -->
                        <div class="col-12 col-xl-4">
                            <div class="quick-links-card">
                                <h4 class="quick-links-title">Quick Links</h4>
                                <div class="quick-links-buttons">
                                    <button class="quick-link-btn" (click)="onAddPlanClick()">
                                        <i class="bi bi-star-fill quick-link-icon"></i>
                                        <span>Add Plan</span>
                                    </button>
                                    <button class="quick-link-btn" (click)="onViewPlanHistoryClick()">
                                        <i class="bi bi-eye-fill quick-link-icon"></i>
                                        <span>View Plan History</span>
                                    </button>
                                    <button class="quick-link-btn" (click)="onViewPaymentHistoryClick()">
                                        <i class="bi bi-wallet-fill quick-link-icon"></i>
                                        <span>View Payment History</span>
                                    </button>
                                    <button class="quick-link-btn" (click)="onUpdateBillingDetailsClick()">
                                        <i class="bi bi-receipt-cutoff quick-link-icon"></i>
                                        <span>{{ hasBillingDetails ? 'Update Billing Details' : 'Add Billing Details' }}</span>
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <!-- Footer (after both tabs so it never sits between content) -->
            <div class="account-footer">
                <a routerLink="/privacy-policy" class="privacy-policy-link">Privacy Policy</a>
            </div>
        </div>
    </div>
</div>

<!-- Two-Factor Authentication Setup Dialog -->
<div class="two-factor-overlay" *ngIf="showTwoFactorDialog" (click)="onDialogBackdropClick($event)">
    <div class="two-factor-dialog" (click)="$event.stopPropagation()">
        <h2 class="dialog-title">Two-Factor Authentication Setup</h2>
        <div class="dialog-content">
            <!-- QR Code Section -->
            <div class="qr-section">
                <div class="qr-code-container">
                    <img [src]="qrCodeUrl" alt="QR Code" class="qr-code" *ngIf="qrCodeUrl">
                    <div class="qr-placeholder" *ngIf="!qrCodeUrl">

                        <svg width="195" height="195" viewBox="0 0 195 195" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <rect x="0.5" y="0.5" width="194" height="194" stroke="#22C063" />
                            <path d="M28.875 28.875H51.75V51.75H28.875V28.875Z" fill="#22C063" />
                            <path d="M74.625 6V74.625H6V6H74.625ZM63.1875 17.4375H17.4375V63.1875H63.1875V17.4375ZM51.75 143.25H28.875V166.125H51.75V143.25Z" fill="#22C063" />
                            <path d="M74.625 120.375V189H6V120.375H74.625ZM17.4375 131.812V177.562H63.1875V131.812H17.4375ZM143.25 28.875H166.125V51.75H143.25V28.875Z" fill="#22C063" />
                            <path d="M120.375 6V74.625H189V6H120.375ZM177.562 17.4375V63.1875H131.812V17.4375H177.562ZM97.5 17.4375V6H108.938V28.875H97.5V51.75H86.0625V17.4375H97.5ZM97.5 74.625V51.75H108.938V74.625H97.5ZM74.625 97.5V86.0625H86.0625V74.625H97.5V97.5H108.938V86.0625H166.125V97.5H120.375V108.938H86.0625V97.5H74.625ZM74.625 97.5V108.938H28.875V97.5H17.4375V108.938H6V86.0625H40.3125V97.5H74.625ZM189 108.938H177.562V86.0625H189V108.938ZM177.562 108.938H166.125V131.812H189V120.375H177.562V108.938ZM131.812 108.938H154.688V120.375H143.25V131.812H131.812V108.938ZM154.688 143.25V131.812H143.25V143.25H131.812V154.688H108.938V166.125H143.25V143.25H154.688ZM154.688 143.25H189V154.688H166.125V166.125H154.688V143.25ZM108.938 131.812V143.25H120.375V120.375H86.0625V131.812H108.938Z" fill="#22C063" />
                            <path d="M86.0625 143.25H97.5V177.562H143.25V189H86.0625V143.25ZM189 166.125V189H154.688V177.562H177.562V166.125H189Z" fill="#22C063" />
                        </svg>
                    </div>
                </div>

                <p class="scan-instruction">Scan this QR code with your authenticator app</p>
                <p class="app-suggestion">(Google Authenticator, Authy or similar)</p>
            </div>

            <!-- Setup Instructions -->
            <div class="instructions-box">
                <div class="instructions-header">
                    <i class="bi bi-info-circle info-icon"></i>
                    <span class="text-light">Setup Instructions</span>
                </div>
                <ol class="instructions-list">
                    <li>Open your authenticator app</li>
                    <li>Scan the QR code above</li>
                    <li>Enter the 6 digit code below to verify</li>
                </ol>
            </div>

            <!-- Verification Code Input -->
            <div class="verification-section">
                <label class="verification-label">Verification Code</label>
                <input type="text" class="verification-input" [(ngModel)]="verificationCode" placeholder="000000" maxlength="6" (input)="onCodeInput($event)">
            </div>

            <!-- Verify Button -->
            <button class="verify-btn" (click)="onVerifyAndEnable()" [disabled]="!isCodeValid()">
                Verify & Enable 2FA
            </button>
        </div>
    </div>
</div>

<!-- Plan History Modal -->
<div class="plan-history-overlay" *ngIf="showPlanHistoryModal" (click)="closePlanHistoryModal()">
    <div class="plan-history-modal" (click)="$event.stopPropagation()">
        <div class="plan-history-header">
            <button class="plan-history-close-btn" (click)="closePlanHistoryModal()">
                <i class="bi bi-x-lg"></i>
            </button>
            <h2 class="plan-history-title">Plan History</h2>
        </div>

        <div class="plan-history-content">
            <table class="plan-history-table">
                <thead>
                    <tr>
                        <th>Plan Name</th>
                        <th>Credits</th>
                        <th>Status</th>
                        <th>Start Date</th>
                        <th>End Date</th>
                    </tr>
                </thead>
                <tbody>
                    <tr *ngIf="planHistoryData.length === 0">
                        <td colspan="4" class="no-history-message">No plan history available</td>
                    </tr>
                    <tr *ngFor="let plan of planHistoryData">
                        <td>{{ plan.planName }}</td>
                        <td>{{ plan.totalCredits}}</td>
                        <td>
                            <span class="status-badge">
                                <i [class]="getStatusIconClass(plan.status)"></i>
                                {{ plan.status }}
                            </span>
                        </td>
                        <td>{{ plan.startDate }}</td>
                        <td>{{ plan.endDate }}</td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
</div>

<!-- Payment History Modal -->
<div class="payment-history-overlay" *ngIf="showPaymentHistoryModal" (click)="closePaymentHistoryModal()">
    <div class="payment-history-modal" (click)="$event.stopPropagation()">
        <div class="payment-history-header">
            <button class="payment-history-close-btn" (click)="closePaymentHistoryModal()">
                <i class="bi bi-x-lg"></i>
            </button>
            <h2 class="payment-history-title">Payment History</h2>
        </div>

        <div class="payment-history-content">
            <table class="payment-history-table">
                <thead>
                    <tr>
                        <th>Plan Name</th>
                        <th>Amount</th>
                        <th>Credits</th>
                        <th>Status</th>
                        <th>Payment Method</th>
                        <th>Date</th>
                        <th>Invoice</th>
                    </tr>
                </thead>
                <tbody>
                    <tr *ngIf="paymentHistoryData.length === 0">
                        <td colspan="7" class="no-history-message">No payment history available</td>
                    </tr>
                    <tr *ngFor="let payment of paymentHistoryData">
                        <td>{{ payment.planName }}</td>
                        <td>{{ payment.amount }}</td>
                        <td>{{ payment.credits }}</td>
                        <td>
                            <span class="status-badge">
                                <i [class]="getPaymentStatusIconClass(payment.status)"></i>
                                {{ payment.status }}
                            </span>
                        </td>
                        <td>{{ payment.paymentMethod || 'N/A' }}</td>
                        <td>{{ payment.date }}</td>
                        <td>
                            <div class="invoice-actions" *ngIf="isCompletedPayment(payment)">
                                <button
                                    type="button"
                                    class="invoice-action-btn"
                                    (click)="onViewInvoice(payment, $event)"
                                    [disabled]="invoiceBusyId === payment.transactionId"
                                    title="View invoice"
                                    aria-label="View invoice">
                                    <i class="bi bi-eye"></i>
                                </button>
                                <button
                                    type="button"
                                    class="invoice-action-btn invoice-action-btn-primary"
                                    (click)="onDownloadInvoice(payment, $event)"
                                    [disabled]="invoiceBusyId === payment.transactionId"
                                    title="Download invoice"
                                    aria-label="Download invoice">
                                    <i class="bi bi-download"></i>
                                </button>
                            </div>
                            <span class="invoice-unavailable" *ngIf="!isCompletedPayment(payment)">-</span>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
</div>

<app-billing-details-dialog
    *ngIf="showBillingModal"
    [existingDetails]="billingDetails"
    [title]="hasBillingDetails ? 'Update Billing Details' : 'Add Billing Details'"
    [subtitle]="pendingInvoiceAction ? 'Add billing details to generate your invoice. You can update these later from My Subscription.' : 'These details will appear on your invoices. You can update them anytime.'"
    (saved)="onBillingDetailsSaved($event)"
    (closed)="closeBillingModal()">
</app-billing-details-dialog>

<!-- Activate Plan Confirmation Modal -->
<div class="activate-plan-overlay" *ngIf="showActivatePlanModal" (click)="closeActivatePlanModal()">
    <div class="activate-plan-modal" (click)="$event.stopPropagation()">
        <div class="activate-plan-header">
            <button class="activate-plan-close-btn" (click)="closeActivatePlanModal()">
                <i class="bi bi-x-lg"></i>
            </button>
        </div>
        <div class="activate-plan-content">
            <div class="activate-plan-icon">
                <i class="bi bi-exclamation-triangle-fill"></i>
            </div>
            <h2 class="activate-plan-title">Activate Plan</h2>
            <p class="activate-plan-message">
                Are you sure you want to activate "<strong>{{ planToActivate?.name }}</strong>"? This will replace your current
                plan.
            </p>
            <div class="activate-plan-buttons">
                <button type="button" class="activate-plan-cancel-btn" (click)="closeActivatePlanModal()">
                    Cancel
                </button>
                <button type="button" class="activate-plan-confirm-btn" (click)="onConfirmActivatePlan()" [disabled]="isActivatingPlan === planToActivate?.subscriptionId">
                    <span *ngIf="isActivatingPlan !== planToActivate?.subscriptionId">Activate</span>
                    <span *ngIf="isActivatingPlan === planToActivate?.subscriptionId">Activating...</span>
                </button>
            </div>
        </div>
    </div>
</div>